import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api-client';
import { emitToast } from '@/lib/toast-bus';

const FORBIDDEN_TOAST = 'You don’t have permission to do that';

function maybeEmitForbiddenToast(error: unknown): void {
  if (error instanceof ApiError && error.status === 403) {
    emitToast({ message: FORBIDDEN_TOAST });
  }
}

type QueryOptions = {
  staleTime?: number;
  retry?: number | boolean;
};

export function createGlobalErrorQueryClient(options: QueryOptions = {}): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: options.staleTime ?? 5 * 60 * 1000,
        retry: options.retry ?? 1,
      },
    },
    mutationCache: new MutationCache({
      onError: maybeEmitForbiddenToast,
    }),
    queryCache: new QueryCache({
      onError: maybeEmitForbiddenToast,
    }),
  });
}
